import { CopyIcon, TooltipIconButton, toast } from "@carbon6/c6-frontend-design";
import { createLogger } from "@/shared/logging";

const logger = createLogger("shared/ui/copyButton");

type CopyButtonProps = {
  /** 클립보드에 넣을 값. */
  value: string;
  /** 무엇을 복사하는지. 접근 이름과 툴팁, 성공 문구가 함께 쓴다. 예) `원본 주소`. */
  label: string;
};

/**
 * 값 하나를 클립보드로 옮기는 버튼.
 *
 * 비보안 컨텍스트(HTTP)나 권한 거부에서 `navigator.clipboard` 는 조용히 실패한다 — 사용자가
 * 눌렀는데 아무 일도 없는 상태를 만들지 않으려고 실패를 토스트로 알린다.
 */
export function CopyButton({ label, value }: CopyButtonProps) {
  async function handleCopy(): Promise<void> {
    try {
      await navigator.clipboard.writeText(value);
      toast.success(`${label}을(를) 복사했습니다.`);
    } catch (error: unknown) {
      logger.warn("Clipboard write failed.", error);
      toast.warning(`${label}을(를) 복사하지 못했습니다. 값을 직접 선택해 복사해 주세요.`);
    }
  }

  return (
    <TooltipIconButton
      aria-label={`${label} 복사`}
      size="xs"
      tooltip={`${label}을(를) 복사합니다.`}
      variant="ghost"
      onClick={() => void handleCopy()}
    >
      <CopyIcon />
    </TooltipIconButton>
  );
}
